import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Send Batch Mappings',
  make: () => ({
    key: [],
    request: (batchMappings: any[]) => async ({ http }: any) => {
      const data = await http({
        method: 'PUT',
        route: '/source-mappings',
        data: { actions: batchMappings },
      });

      return data;
    },
  }),
});
